import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="inline-block mb-4 cursor-pointer">
                <span className="text-2xl font-bold" style={{ fontFamily: "var(--font-heading)" }}>
                  <span className="text-primary-400">99</span>
                  <span className="text-background-100">视频</span>
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                聚合香蕉视频、红桃视频、91视频、蜜桃视频等热门平台，提供高清免费在线观看，不缓冲流畅播放。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                <a href="#video-categories" className="cursor-pointer">视频分类</a>
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">热门平台</h4>
              <ul className="space-y-2.5">
                <li>
                  <span className="text-sm text-background-400 cursor-pointer hover:text-primary-400 transition-colors">香蕉视频</span>
                </li>
                <li>
                  <span className="text-sm text-background-400 cursor-pointer hover:text-primary-400 transition-colors">红桃视频</span>
                </li>
                <li>
                  <span className="text-sm text-background-400 cursor-pointer hover:text-primary-400 transition-colors">91视频</span>
                </li>
                <li>
                  <span className="text-sm text-background-400 cursor-pointer hover:text-primary-400 transition-colors">蜜桃视频</span>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                    用户口碑
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                    联系方式
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 99视频 All Rights Reserved. 本站所有视频内容均来自第三方平台。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-primary-400 transition-colors">用户协议</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-primary-400 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}